import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "../AuthContext";
//import axios from "axios";
import "../styles/UserRegisterModal.css"; // CSS 파일 import
import AddLog from "./AddLog"; // ✅ 로그 저장 함수 가져오기

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; 

const UserRegisterModal = ({ plist, glist, onClose, onUserAdded }) => {
    const { user } = useAuth();
    //const { user, setUser } = useAuth();
    //const [idMessage, setIdMessage] = useState("");  // 메시지 표시
    const [isIdValid, setIsIdValid] = useState(false); // 중복 여부 확인

    const [userId, setUserId] = useState("");    
    const [userType, setUserType] = useState("U");
    const [name, setName] = useState("");
    const [phone1, setPhone1] = useState("");
    const [phone2, setPhone2] = useState("");
    const [phone3, setPhone3] = useState("");
    const [email1, setEmail1] = useState("");
    const [email2, setEmail2] = useState("");
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [partnerCode, setPartnerCode] = useState("");
    const [governmentCode, setGovernmentCode] = useState("");
    //const [plist, setPlist] = useState([]);
    //const [glist, setGlist] = useState([]);

    const hasRun = useRef(false);

    useEffect(() => {
        
        if (hasRun.current) return; // 이미 실행되었으면 종료

        hasRun.current = true; // 첫 실행 후 플래그 설정

        if (user.userType === "S") {
            //getPartnerCode();
            //getGovernmentCode();
            if (userType === "S" || userType === "G") {
                setPartnerCode(""); // 조건1: 숨김 + 빈값
                setGovernmentCode(""); // 조건1: 숨김 + 빈값
            }
        } else {
            setPartnerCode(user.partnerCode); // 조건2: 숨김 + user.partnerCode로 설정
            setGovernmentCode(user.governmentCode); // 조건1: 숨김 + 빈값
        }
    }, [user.partnerCode, user.governmentCode, user.userType, userType]); // userType 또는 user.userType이 변경될 때 실행

    /*
    // 파트너 코드 리스트 가져오기
    const getPartnerCode = async () => {
        
        try {
            const response = await fetch(`${API_BASE_URL}/api/Partner/get-list`);
            const data = await response.json();

            if (response.ok) {
                setPlist(data.plist);
                //console.log(data.plist);
            } else {
                alert(data.message || "조회 실패");
            }

        } catch (error) {            
            alert("파트너 리스트 조회 중 오류가 발생했습니다.");                        
        }
    };

    // 파트너 코드 리스트 가져오기
    const getGovernmentCode = async () => {

        try {
            const response = await fetch(`${API_BASE_URL}/api/Government/get-list`);
            const data = await response.json();

            if (response.ok) {
                setGlist(data.glist);
                //console.log(data.glist);
            } else {
                alert(data.message || "조회 실패");
            }

        } catch (error) {
            alert("관공서 리스트 조회 중 오류가 발생했습니다.");
        }
    };
    */

    // 아이디 중복 확인
    const handleCheckDuplicate = async () => {
        const trimmedUserId = userId.trim();

        if (trimmedUserId.length < 6) {
            alert("아이디는 6자 이상 입력해야됩니다.");
            //setIdMessage("ID를 입력해 주세요.");
            setIsIdValid(false);
            return;
        }

        try {            
            const response = await fetch(`${API_BASE_URL}/api/Account/check-duplicate?userId=${trimmedUserId}`);
            const data = await response.json();

            if (data.exists) {
                alert("이미 사용 중인 ID입니다.");
                //setIdMessage("이미 사용 중인 ID입니다.");
                setIsIdValid(false);
            } else {
                alert("사용 가능한 ID입니다.");
                //setIdMessage("사용 가능한 ID입니다.");
                setIsIdValid(true);
            }
        } catch (error) {
            //console.error("ID 중복 확인 오류:", error);
            alert("중복 확인 중 오류가 발생했습니다.");
            //setIdMessage("중복 확인 중 오류가 발생했습니다.");
            setIsIdValid(false);
        }
    };

    // 카카오 주소 검색
    const handleSearchAddress = () => {
        new window.daum.Postcode({
            oncomplete: (data) => {
                // 주소를 DB에 저장
                setAddress1(data.address);
            },
            width: 500, // 창 너비
            height: 600, // 창 높이
        }).open({
            left: (window.screen.width / 2) - 250,  // 중앙 정렬 (화면 너비 기준)
            top: (window.screen.height / 2) - 300   // 중앙 정렬 (화면 높이 기준)
        });
    };

    // 저장 버튼 클릭
    const handleSave = async () => { // 'async' 추가
        
        if (userId.length < 6) {
            alert("아이디는 6자 이상 입력해야됩니다.");
            setTimeout(() => {
                document.getElementsByName("userid")[0].focus();
            }, 0);
            return;
        }
        else if (!isIdValid) {
            alert("아이디 중복확인을 해주세요!");
            setTimeout(() => {
                document.getElementsByName("useridbt")[0].focus();
            }, 0);
            return;
        }
        else if (!name.trim()) {
            alert("이름을 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("username")[0].focus();
            }, 0);
            return;
        }
        else if (!phone1.trim() || !phone2.trim() || !phone3.trim()) {
            alert("전화번호를 입력 해주세요!");
            setTimeout(() => {
                if (phone1.trim() === "") { document.getElementsByName("userphone1")[0].focus();  }
                else if (phone2.trim() === "") { document.getElementsByName("userphone2")[0].focus(); }
                else if (phone3.trim() === "") { document.getElementsByName("userphone3")[0].focus(); }
            }, 0);
            return;
        }
        else if (!email1.trim() || !email2.trim() ) {
            alert("이메일 주소를 입력 해주세요!");
            setTimeout(() => {
                if (email1.trim() === "") { document.getElementsByName("useremail1")[0].focus(); }
                else if (email2.trim() === "") { document.getElementsByName("useremail2")[0].focus(); }                
            }, 0);
            return;
        }
        else if (!address1.trim() ) {
            alert("주소검색으로 기본주소를 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("useraddrbt")[0].focus();
            }, 0);
            return;
        }
        else if (!address2.trim() ) {
            alert("나머지 주소를 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("useraddr2")[0].focus();
            }, 0);
            return;
        }

        if (userType === 'S') {
            setPartnerCode("");
            setGovernmentCode("");
        }
        if (userType === 'G') {
            setPartnerCode("");            
        }
        
        const newUser = {
            UserId: userId,
            UserType: userType,
            Password: "$2a$11$NAE2MpRB1a3KIQAL1Eq3M.K61LnDMeedB0wp.M44NVgSz.qF9caMe",
            Name: name.trim(),
            Phone: `${phone1}-${phone2}-${phone3}`, // 백엔드와 일치
            Email: `${email1.trim()}@${email2.trim() }`,
            Address1: address1,
            Address2: address2.trim(),
            PartnerCode: partnerCode.trim(), // 백엔드와 대소문자 일치
            GovernmentCode: governmentCode.trim(), // 백엔드와 대소문자 일치
            UserDate: new Date().toISOString().split("T")[0], // YYYY-MM-DD
            Active: "F", // 백엔드와 일치
        };

        //console.log("신규 사용자 정보:", JSON.stringify(newUser, null, 2));
        //alert(newUser.userId);

        try {
            
            const response = await fetch(`${API_BASE_URL}/api/Account/add-user`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newUser),
            });

            const data = await response.json();
            if (response.ok) {

                await AddLog(user.userId, "", newUser.UserId, "5-1");

                alert("사용자 등록이 완료되었습니다.");
                onUserAdded();  // 리스트 갱신을 요청하는 콜백 호출
                onClose();
            } else {
                alert("사용자 등록에 실패했습니다: " + data.message);
                //console.log("응답 상태 코드:", response.status);
                //console.log("서버 응답 데이터:", data);
            }
            
        } catch (error) {
            //console.error("오류:", error);
            alert("사용자 등록 중 오류가 발생했습니다.");
        }
       
        onClose();
    };

    return (
        <div className="modal-overlay2">
            <div className="modal-content2">
                {/* 모달 헤더 */}
                <div className="modal-header">
                    <h2>사용자 신규 등록</h2>
                    <button className="modal-close-btn" onClick={onClose}><i className="fa fa-times-circle"></i></button>
                </div>

                {/* 입력 필드 */}
                <div className="form-group2">
                    <label>사용자 ID</label>
                    <div className="input-group2">                        
                        <input
                            name="userid"
                            type="text"
                            maxLength="18"
                            value={userId}
                            onChange={(e) => setUserId(e.target.value.trim())}
                            disabled={isIdValid} // isIdValid가 true이면 편집 불가
                            style={{ backgroundColor: isIdValid ? "Whitesmoke" : "white" }} // 배경색 변경
                        />

                        <button
                            name="useridbt"
                            className={isIdValid ? "check-btn2" : "check-btn"}
                            onClick={handleCheckDuplicate}
                        >
                            <i className="fa fa-user"></i>
                        </button>
                    </div>
                    
                </div>

                {user.userType === "S" && (
                    <div className="form-group2">
                        <label>회원 구분</label>
                        <div className="input-group2">
                            <select value={userType} 
                                onChange={(e) => {
                                    setUserType(e.target.value);

                                    setPartnerCode("");
                                    setGovernmentCode("");
                                }}>
                                <option value="U">사용자</option>
                                <option value="P">파트너</option>
                                <option value="G">관공서</option>
                                <option value="S">빛담 관리자</option>
                            </select>
                        </div>
                    </div>
                )}

                <div className="form-group2">
                    <label>이름</label>
                    <div className="input-group2">
                        <input name="username" type="text" maxLength="18" value={name} onChange={(e) => setName(e.target.value)} />
                    </div>
                </div>

                <div className="form-group2">
                    <label>전화번호</label>
                    <div className="phone-group2">
                        <input
                            name="userphone1"
                            type="text"
                            maxLength="3"
                            value={phone1}
                            onChange={(e) => setPhone1(e.target.value.replace(/[^0-9]/g, ""))} // 숫자만 입력 가능
                        />
                        <span>-</span>
                        <input
                            name="userphone2"
                            type="text"
                            maxLength="4"
                            value={phone2}
                            onChange={(e) => setPhone2(e.target.value.replace(/[^0-9]/g, ""))} // 숫자만 입력 가능
                        />
                        <span>-</span>
                        <input
                            name="userphone3"
                            type="text"
                            maxLength="4"
                            value={phone3}
                            onChange={(e) => setPhone3(e.target.value.replace(/[^0-9]/g, ""))} // 숫자만 입력 가능
                        />
                    </div>
                </div>

                <div className="form-group2">
                    <label>이메일</label>
                    <div className="email-group2">
                        <input name="useremail1" type="text" maxLength="20" value={email1} onChange={(e) => setEmail1(e.target.value)} />
                        <span>@</span>
                        <input name="useremail2" type="text" maxLength="20" value={email2} onChange={(e) => setEmail2(e.target.value)} />
                    </div>
                </div>

                <div className="form-group2">
                    <label>주소1</label>
                    <div className="input-group2">
                        <input type="text" readOnly value={address1} />
                        <button name="useraddrbt" className="search-btn" onClick={handleSearchAddress}><i className="fa fa-search"></i></button>
                    </div>
                </div>

                <div className="form-group2">
                    <label>주소2</label>
                    <div className="input-group2">
                        <input name="useraddr2" type="text" maxLength="40" value={address2} onChange={(e) => setAddress2(e.target.value)} />
                    </div>
                </div>

                {user.userType === "S" && !(userType === "S" || userType === "G") && (
                    <div className="form-group2">
                        <label>파트너 코드</label>
                        <div className="input-group2">
                            <select
                                name="partnerCode"
                                value={partnerCode}
                                onChange={(e) => {
                                    setPartnerCode(e.target.value);

                                    // 선택한 파트너 정보 가져오기
                                    const selectedPartner = plist.find(p => p.partnerCode === e.target.value);

                                    // governmentCode 자동 설정 (해당 partner의 governmentCode)
                                    //console.log(selectedPartner);
                                    if (selectedPartner) {
                                        setGovernmentCode(selectedPartner.governmentCode || "");
                                    }
                                    else {
                                        setGovernmentCode("");
                                    }
                                }}
                            >
                                <option value="">파트너를 선택하세요</option> {/* 기본값 */}
                                {plist.map((partner) => (
                                    <option key={partner.snum} value={partner.partnerCode}>
                                        {partner.snum}, {partner.partnerCode} : {partner.partnerName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}

                {user.userType === "S" && !(userType === "S") && (
                    <div className="form-group2">
                        <label>관공서 코드</label>
                        <div className="input-group2">
                            <select
                                name="governmentCode"
                                value={governmentCode}
                                onChange={(e) => setGovernmentCode(e.target.value)}
                                disabled={userType === "U" || userType === "P"} // U 또는 P일 때 편집 불가
                            >
                                <option value="">관공서를 선택하세요</option> {/* 기본값 */}
                                {glist.map((government) => (
                                    <option key={government.snum} value={government.governmentCode}>
                                        {government.snum}, {government.governmentCode} : {government.governmentName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}

                {/* 저장 버튼 */}
                <button className="save-btn" onClick={handleSave}>저장</button>
            </div>
        </div>
    );
};

export default UserRegisterModal;
